import axios from 'axios';
import { getAuthToken, useAuthStore } from '../stores/authStore';

// Base URL: when VITE_API_BASE_URL is empty we fall back to relative '' so the
// Vite dev proxy (/api -> :20001) handles routing with no CORS. In production
// set VITE_API_BASE_URL to the backend origin.
const baseURL = import.meta.env.VITE_API_BASE_URL || '';

const apiClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach the JWT bearer token from the auth store to every request.
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

// On 401, the session is dead: clear auth and bounce to /login (unless we are
// already there, to avoid a redirect loop). On 403 password_change_required
// (BP 26 — requireAuth's structural forced-rotation gate) the session is still
// valid, so we do NOT log out; we just send the student to change their
// password, unless they're already on that page.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.error;
    if (status === 401) {
      useAuthStore.getState().logout();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.assign('/login');
      }
    } else if (status === 403 && code === 'password_change_required') {
      if (!window.location.pathname.startsWith('/account/password')) {
        window.location.assign('/account/password?forced=1');
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
